import React, { useContext, useEffect, useRef, useState } from "react";
import HeartIcon from "../../icons/HeartIcon";
import { CDN_BASE_URL } from "../../config";
import { httpReauest } from "../../utils/httpRequest";
import { Link, useParams, useSearchParams } from "react-router-dom";
import ShareIcon from "../../icons/ShareIcon";
import ShareModal from "../../components/common/mobile/ShareModal";
import { priceComma } from "../../utils/priceComma";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { getTiming } from "../../utils/getTiming";
import ArrowDownIcon from "../../icons/ArrowDownIcon";
import Compare from "../../components/layout/Compare";
import ComapreMobile from "../../components/common/mobile/ComapreMobile";
import { Helmet } from "react-helmet";
import CommentFormMobileVehicle from "../../components/common/mobile/CommentFormMobileVehicle";
import CommentsVehicle from "../../components/common/mobile/CommentsVehicle";
import axios from "axios";
import RequestTalkModal from "../../components/common/mobile/RequestTalkModal";
import { ProductContext } from "../../context/ProductContext";
import { FaCheck, FaTimes } from "react-icons/fa";
import { ExpertContext } from "../../context/ExpertContext";
import { DealerDataContext } from "../../context/DealerDataContext";
import ProductCardMobile from "../../components/common/mobile/ProductCardMobile";
import BlogCardImage from "../../components/common/card/BlogCardImage";

const ProductDetailsMobile = () => {
  const { name, category, brand, vehicle_number } = useParams();
  const [loading, setLoading] = useState();
  const [related, setrelated] = useState();
  const [blogs, setblogs] = useState();
  const [selected, setselected] = useState();
  const [selectedSwich, setselectedSwich] = useState("توضیحات");
  const [minPrice, setminPrice] = useState();
  const [share, setShare] = useState();
  const [show, setShow] = useState();
  const [chat, setChat] = useState();
  const [content, setcontent] = useState();

  const { expertUser } = useContext(ExpertContext);
  const { dealerData } = useContext(DealerDataContext);

  const url = `https://1924.ir/${category}/${brand}/${name}/${vehicle_number}`;

  useEffect(() => {
    getData();
  }, [name]);

  async function getData() {
    setLoading(true);
    await httpReauest(
      "GET",
      `/vehicle/details/${category}/${brand}/${name}/${vehicle_number}`,
      {},
      {}
    ).then(({ data }) => {
      setselected(data?.data?.vehicle);
      setcontent(data?.data?.url);
      setrelated(data?.data?.related);
      setblogs(data?.data?.blogs);
    });
    setLoading(false);
  }

  const now = new Date();
  const newTime = now.getTime() - new Date(selected?.createdAt).getTime();
  const hour = newTime / 86400000;

  const [liked, setLiked] = useState();
  const [count, setcount] = useState(0);

  const ref = useRef();

  useEffect(() => {
    if (selected?.liked) {
      setLiked(true);
    } else {
      setLiked(false);
    }
    setcount(selected?.like);
  }, [selected]);

  async function handleLike() {
    if (!liked) {
      setLiked(true);
      setcount(count + 1);
      const { data: data2 } = await axios.get(
        "https://api.ipify.org/?format=json"
      );
      await httpReauest(
        "POST",
        "/vehicle/like",
        { ip: data2.ip, vehicle: selected?._id },
        {}
      );
    } else {
      setLiked(false);
      setcount(count - 1);
      const { data: data2 } = await axios.get(
        "https://api.ipify.org/?format=json"
      );
      await httpReauest(
        "DELETE",
        "/vehicle/like/delete",
        { ip: data2.ip, vehicle: selected?._id },
        {}
      );
    }
  }

  return (
    <div className="pb-7">
      {show && <RequestTalkModal setShow={setShow} />}
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {selected?.meta_title ? selected?.meta_title : selected?.name}
        </title>
        <meta
          name="description"
          content={
            selected?.meta_desc
              ? selected?.meta_desc
              : `آگهی فروش ${selected?.name}`
          }
        />
        <meta name="keywords" content={content?.meta_keywords} />
        <meta
          name="og:description"
          content={
            selected?.meta_desc
              ? selected?.meta_desc
              : `آگهی فروش ${selected?.name}`
          }
        />
        <meta
          name="og:title"
          content={selected?.meta_title ? selected?.meta_title : selected?.name}
        />
        <link rel="canonical" href={url} />
      </Helmet>{" "}
      {share && <ShareModal url={url} setShare={setShare} />}
      <Swiper autoplay={{ delay: 4500 }} modules={[Autoplay]}>
        <SwiperSlide>
          {selected?.img?.img_webp ? (
            <picture>
              <source
                type="image/webp"
                srcset={CDN_BASE_URL + selected?.img?.img_webp}
              />
              <img
                src={CDN_BASE_URL + selected?.img?.img_jpg}
                className="rounded-[10px] w-full h-[400px] object-contain"
                alt={selected?.name}
                title={selected?.name}
              />
            </picture>
          ) : selected?.img ? (
            <img
              src={CDN_BASE_URL + selected?.img}
              className="rounded-[10px] w-full h-[400px] object-contain"
              alt={selected?.name}
              title={selected?.name}
            />
          ) : (
            <img
              src={"/no-image.jpg"}
              className="rounded-[10px] w-full h-[400px] object-contain"
              alt={selected?.name}
              title={selected?.name}
            />
          )}
        </SwiperSlide>
        {selected?.images?.map((e) => (
          <SwiperSlide>
            {e?.img_webp ? (
              <picture>
                <source type="image/webp" srcset={CDN_BASE_URL + e?.img_webp} />
                <img
                  src={CDN_BASE_URL + e?.img_jpg}
                  className="rounded-[10px] w-full h-[400px] object-contain"
                  alt={selected?.name}
                  title={selected?.name}
                />
              </picture>
            ) : (
              <img
                src={CDN_BASE_URL + e}
                className="rounded-[10px] w-full h-[400px] object-contain"
                alt={selected?.name}
                title={selected?.name}
              />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="flex justify-between items-center py-2">
        <span className="flex gap-3 items-center">
          <span className="flex gap-2 items-center">
            {" "}
            <HeartIcon select={liked} onClick={handleLike} color={"#2E3132"} />
            <p>{count}</p>
          </span>
          <span
            onClick={() => {
              setselectedSwich("نظرات");
              setTimeout(() => {
                window.scrollTo({ top: 90000000000, behavior: "smooth" });
              }, 500);
            }}
            className="flex gap-2 items-center"
          >
            {" "}
            <img className="w-[20px]" src="/Chat.png" alt="" />
            <p>{selected?.commentCount}</p>
          </span>
        </span>
        <span className="flex gap-3 items-center">
          <span
            onClick={() => setShare(true)}
            className="flex gap-2 items-center"
          >
            {" "}
            <img className="w-[20px]" src="/share.png" alt="" />
          </span>
          <span>{getTiming(hour)}</span>
        </span>
      </div>
      <div className="flex justify-between items-center py-1 font-[700] text-[18px]">
        <h2>{selected?.name}</h2>
        <p className="text-[#1AA126]">
          {selected?.no_price
            ? "توافقی"
            : priceComma(Number(selected?.price * 1000000000).toFixed(0), 2)}
        </p>
      </div>
      <div className="flex flex-col gap-3 py-4">
        <div
          className={`grid overflow-hidden duration-200 grid-cols-2  gap-3 ps-3 text-[11px]`}
        >
          {selected?.details?.map((item) => {
            if (item?.name !== "") {
              return (
                <span className="flex gap-2 items-start ">
                  <span className="font-bold relative yellow-circle-small">
                    {item?.name}:
                  </span>{" "}
                  <span>{item?.value}</span>
                </span>
              );
            }
          })}
          {expertUser ? (
            <>
              <span className="flex gap-2  items-start">
                <span className="font-bold relative yellow-circle-small">
                  اسم کارشناس:
                </span>{" "}
                <span>{selected?.expert_name}</span>
              </span>
              <span className="flex gap-2 relative yellow-circle-small ">
                <span className="font-bold">شماره تماس کارشناس:</span>{" "}
                <span>{selected?.expert_phone}</span>
              </span>
            </>
          ) : null}
          <span className="col-span-full">{selected?.desc}</span>
        </div>
      </div>
      <div className="py-3 grid grid-cols-2 gap-3">
        <Link
          to={`tel:${dealerData?.phone}`}
          className="btn-brand-mobile  w-full block text-center col-span-full"
        >
          تماس جهت خرید - {dealerData?.phone}
        </Link>
        <button
          onClick={() => setShow(true)}
          className="border-brand-2 p-3 w-full block text-center col-span-full"
        >
          درخواست مشاوره تلفنی
        </button>
        <Link
          to={"/chat"}
          className="border-brand-2 p-3 w-full block text-center"
        >
          گفتگو با کارشناس
        </Link>
        <button
          onClick={() => {
            setselectedSwich("مقایسه مشخصات");
            ref.current.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "start",
            });
          }}
          className="border-brand-2 p-3 w-full block text-center"
        >
          مقایسه
        </button>
      </div>
      <div className="w-full border rounded-[4px] border-green-600 grid grid-cols-6 p-3 gap-3">
        <span className="flex col-span-2 flex-col items-center justify-center">
          <p className="font-[600] text-[12px]">
            {selected?.rate ? "کارشناسی شده" : "قیمت اعلامی مالک"}
          </p>
        </span>
        <span className="col-span-4">
          <div className="grid grid-cols-3 w-full rounded-full relative mt-2">
            <span className="bg-red-600 p-1 "></span>
            <span className="bg-yellow-500 p-1"></span>
            <span className="bg-green-600 p-1"></span>
            {selected?.rate ? (
              <span
                style={{ right: selected?.rate + "%" }}
                className={`absolute w-[17px] h-[17px] top-[-52%] rounded-full bg-[#00000070] border-double border-[3px] border-white z-10`}
              ></span>
            ) : (
              ""
            )}
          </div>
          {selected?.rate ? (
            <p className=" mt-3 font-[600] text-[14px]">
              {selected?.rate > 66
                ? " قیمت این خودرو منصفانه است!"
                : selected?.rate > 33
                ? "قیمت این خودرو عادی است"
                : "قیمت خودرو منصفانه نیست"}
            </p>
          ) : (
            ""
          )}
          <p className="text-[#2E3132] mt-3 text-[14px]">
            کارشناسی خودرو خود را به ما بسپرید
          </p>
        </span>
      </div>
      <div className="w-full flex gap-3 py-3 mt-2 overflow-x-scroll border-b border-dashed border-[#8E9192] text-[14px]">
        <span
          onClick={() =>
            "توضیحات" === selectedSwich
              ? setselectedSwich("")
              : setselectedSwich("توضیحات")
          }
          className={`${
            selectedSwich === "توضیحات" ? "bg-black text-white" : ""
          } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
        >
          {"توضیحات"}
        </span>
        <span
          onClick={() =>
            "نظرات" === selectedSwich
              ? setselectedSwich("")
              : setselectedSwich("نظرات")
          }
          className={`${
            selectedSwich === "نظرات" ? "bg-black text-white" : ""
          } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
        >
          {"نظرات"}
        </span>

        <span
          onClick={() =>
            "محصولات مرتبط" === selectedSwich
              ? setselectedSwich("")
              : setselectedSwich("محصولات مرتبط")
          }
          className={`${
            selectedSwich === "محصولات مرتبط" ? "bg-black text-white" : ""
          } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
        >
          {"محصولات مرتبط"}
        </span>
        <span
          onClick={() =>
            "آخرین مقالات" === selectedSwich
              ? setselectedSwich("")
              : setselectedSwich("آخرین مقالات")
          }
          className={`${
            selectedSwich === "آخرین مقالات" ? "bg-black text-white" : ""
          } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
        >
          {"آخرین مقالات"}
        </span>
      </div>
      <div ref={ref} className="py-3">
        {selectedSwich === "توضیحات" ? (
          <>
            <h1 className="text-[22px]">{content?.title}</h1>
            <div
              className="desc_details overflow-x-scroll"
              dangerouslySetInnerHTML={{ __html: content?.content }}
            />
          </>
        ) : selectedSwich === "محصولات مرتبط" ? (
          <>
            {related?.map((item) => (
              <ProductCardMobile data={item} />
            ))}
          </>
        ) : selectedSwich === "آخرین مقالات" ? (
          <div className="grid gap-4">
            {blogs?.map((item) => (
              <BlogCardImage data={item} />
            ))}
          </div>
        ) : (
          <>
            <CommentFormMobileVehicle vehicle={selected?._id} />
            <CommentsVehicle vehicle={selected?._id} />
          </>
        )}
      </div>
    </div>
  );
};

export default ProductDetailsMobile;
